import {differenceInYears, isFuture, isValid} from 'date-fns';

// TODO what about lang?
export const validateBirthDate = (birthdate?: Date | number | null) => {
  if (!birthdate) return 'Please enter your birthday.';

  if (!isValid(birthdate))
    return 'This date is not recognized. Please use the format mm/dd/yyyy.';
  if (isFuture(birthdate))
    return 'This date is in the future. Please use the format mm/dd/yyyy.';
  if (differenceInYears(new Date(), birthdate) > 125)
    return 'This date is too far in the past. Please use the format mm/dd/yyyy.';
};

export const isChild = (birthdate: Date, now: Date = new Date()) =>
  differenceInYears(now, birthdate) < 13;

export const isAdult = (birthdate: Date, now: Date = new Date()) =>
  differenceInYears(now, birthdate) >= 18;

export const isTeen = (birthdate: Date, now: Date = new Date()) =>
  !isChild(birthdate, now) && !isAdult(birthdate, now);
